export enum TransportCategoryEnum {
  UNKNOWN = 0,
  BASIC = 1,
  EXPRESS = 2,
  INTERNATIONAL = 3,
}
